import React from 'react'

function InventoryReports() {
  return (
    <div>Inventory Reports</div>
  )
}

export default InventoryReports